import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "18",
  height: "18",
  fill: "none",
  viewBox: "0 0 18 18"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#6ED982",
      d: "M6.594 8.715c0-.172.14-.312.313-.312h6.463a.313.313 0 1 1 0 .625H6.907a.313.313 0 0 1-.313-.313m9.586-2.11-1.731 6.219a.31.31 0 0 1-.301.229H5.97a.31.31 0 0 1-.301-.229L3.275 4.237 1.779 2.29a.313.313 0 0 1 .496-.38l1.532 1.996a.3.3 0 0 1 .053.106l.615 2.198h11.403a.313.313 0 0 1 .302.397m-.713.23H4.65l1.355 4.847q.01.03.01.06l.191.686h7.703zm-6.398 8.049c0 .719-.585 1.304-1.304 1.304a1.305 1.305 0 0 1-1.304-1.304 1.305 1.305 0 0 1 2.608 0m-.625 0a.68.68 0 1 0-1.36.001.68.68 0 0 0 1.36-.001m4.708-4.703H7.126a.313.313 0 0 0 0 .625h6.028a.313.313 0 1 0 0-.625m.53 4.703c0 .719-.584 1.304-1.303 1.304a1.305 1.305 0 0 1-1.304-1.304 1.305 1.305 0 0 1 2.608 0m-.624 0a.68.68 0 1 0-1.36.001.68.68 0 0 0 1.36-.001"
    }, null, -1)
  ]))]))
}
export default { render: render }